// variant-picker-collection.js

var addingToCart = false

document.addEventListener("click", async function(e){

  const sizeBtn = e.target.closest(".size-button")

  if(sizeBtn){

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const container = sizeBtn.closest(".product-options")
    const group = sizeBtn.closest(".btn-options")
    if(!container || !group) return

    const buttons = group.querySelectorAll(".size-button")

    // TOGGLE
    if(sizeBtn.classList.contains("selected")){
      sizeBtn.classList.remove("selected")
    }else{
      buttons.forEach(b => b.classList.remove("selected"))
      sizeBtn.classList.add("selected")
    }

    const addBtn = container.querySelector(".add-to-cart-btn")
    const selected = container.querySelectorAll(".size-button.selected")

    if(addBtn){
      if(selected.length > 0){
        addBtn.disabled = false
        addBtn.textContent = `Agregar a la bolsa (${selected.length} pieza${selected.length>1?'s':''})`
      }else{
        addBtn.disabled = true
        addBtn.textContent = "Seleccionar talla"
      }
    }

    return
  }

  async function updateCartIcon(){

    try{

      const res = await fetch("/cart.js")
      const cart = await res.json()

      const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble")
      const icon = document.querySelector("#cart-icon-bubble")

      if(!icon) return

      if(cart.item_count > 0){

        if(!bubble){
          const div = document.createElement("div")
          div.className = "cart-count-bubble"
          div.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`
          icon.appendChild(div)
        }else{
          const span = bubble.querySelector("span")
          if(span) span.textContent = cart.item_count
        }

      }else{
        if(bubble) bubble.remove()
      }

    }catch(e){
      console.error("Cart icon update error", e)
    }

  }

  const addBtn = e.target.closest(".add-to-cart-btn")
  if(!addBtn) return

  if(addBtn.classList.contains("loading")) return
  if(addingToCart) return

  const container = addBtn.closest(".product-options")
  
  // NUEVO: Detectar si es producto sin variantes (Default Title)
  const hasVariantSelector = container.querySelector(".size-button") !== null
  
  let items = []

  if(hasVariantSelector){
    // Producto CON variantes - comportamiento original
    const selectedVariants = container.querySelectorAll(".size-button.selected")
    items = [...selectedVariants].map(btn => ({
      id: btn.dataset.variantId || btn.dataset.variant,
      quantity: 1
    }))
  } else {
    // Producto SIN variantes (Default Title) - usar variant del botón
    const variantId = addBtn.dataset.variant
    if(variantId){
      items = [{
        id: variantId,
        quantity: 1
      }]
    }
  }

  if(!items.length) return

  try{
    addingToCart = true
    addBtn.classList.add("loading")
    addBtn.disabled = true
    
    // Cambiar texto del botón mientras carga
    const originalText = addBtn.textContent
    addBtn.textContent = "Agregando..."

    const response = await fetch("/cart/add.js",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body: JSON.stringify({ items })
    })

    if(!response.ok) throw new Error("Cart error")

    const data = await response.json()

    await updateCartIcon()

    if (typeof openAddedDrawer === "function") {
      openAddedDrawer(data)
    }

  }catch(err){
    console.error("Add to cart error:", err)
    alert("Error al agregar al carrito. Por favor intenta de nuevo.")
  }finally{
    addingToCart = false
    addBtn.classList.remove("loading")
    
    // Restaurar estado del botón según el tipo de producto
    if(hasVariantSelector){
      const selected = container.querySelectorAll(".size-button.selected")
      if(selected.length > 0){
        addBtn.disabled = false
        addBtn.textContent = `Agregar a la bolsa (${selected.length} pieza${selected.length>1?'s':''})`
      }else{
        addBtn.disabled = true
        addBtn.textContent = "Seleccionar talla"
      }
    } else {
      // Para productos sin variantes, mantener habilitado
      addBtn.disabled = false
      addBtn.textContent = "Agregar al carrito"
    }
  }

}, true) // 👈 fase de captura
